/**
 * OpenPortalButton — active-code portal navigation button.
 *
 * The canonical portal button component owned by active code.
 * Use this instead of inline buttons so portal navigation is always
 * implemented in components/ and Copilot never needs to touch the
 * deprecated story shell for portal button logic.
 *
 * Usage:
 *   import { OpenPortalButton } from '../portal/OpenPortalButton';
 *   <OpenPortalButton onClick={handleViewPortal} disabled={saving} />
 */
import type { ButtonHTMLAttributes } from 'react';

export interface OpenPortalButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
}

export function OpenPortalButton({ label = 'View Portal', children, ...rest }: OpenPortalButtonProps) {
  return (
    <button type="button" {...rest}>
      {children ?? label}
    </button>
  );
}
